export default __webpack_public_path__ + "static/media/trr-food-smallplate-chickpea.0d7b73ba.png";